/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { TimePicker } from '@progress/kendo-react-dateinputs';
import './TimeInput.scss';
import clsx from 'classnames';

/**
 * TimeInput component for time selection
 *
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new DateInput component from '@ui' with `type="time"` prop instead.
 *
 * Migration path:
 * - Import: `import { DateInput } from '@ui';`
 * - Add prop: `type="time"`
 * - API is compatible - same props structure
 *
 * @see {@link frontend/ui/molecules/inputs/form/DateInput/DateInput.tsx}
 * @see {@link docs/ai-knowledge/frontend/component-deprecation-plan.md}
 */
function TimeInput({ id, value, onChange, label, name, required, disabled }) {
  return (
    <div className="qmb-input timeInputContainer">
      <TimePicker 
        id={id} 
        name={name} 
        value={value} 
        onChange={onChange} 
        disabled={disabled} />
      <label
        htmlFor={id}
        className={clsx('qmb-label', { '--required': required })}>
        {label}
      </label>
    </div>
  );
}

export default TimeInput;

TimeInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool
};

TimeInput.defaultProps = {
  value: '',
  name: '',
  onChange: () => {},
  label: '',
  required: false,
  disabled: false
};
